// Google Analytics helper functions

/**
 * Track a button click event
 * @param {string} eventName - Name of the event
 * @param {string} eventLabel - Label for the event (e.g., button name)
 * @param {string} eventCategory - Category of the event (e.g., engagement, navigation)
 */
export const trackButtonClick = (eventName, eventLabel, eventCategory = "engagement") => {
  if (window.gtag) {
    window.gtag("event", eventName, {
      event_category: eventCategory,
      event_label: eventLabel,
    });
  }
};

/**
 * Track a navigation button click with landingPage prefix
 * @param {string} section - Section name (features, how, faq, contact)
 * @param {string} label - Label for the event
 */
export const trackNavigation = (section, label) => {
  if (window.gtag) {
    window.gtag("event", `landingPage_${section}`, {
      event_category: "navigation",
      event_label: label,
    });
  }
};

/**
 * Track a page view event
 * @param {string} pagePath - Path of the page being viewed
 * @param {string} [titleLabel] - Optional label/title for the page (sent as event_label)
 */
export const trackPageView = (pagePath, titleLabel) => {
  if (window.gtag) {
    const eventData = {
      page_path: pagePath,
    };
    
    // Add event_label if titleLabel is provided
    if (titleLabel) {
      eventData.event_label = titleLabel;
    }
    
    window.gtag("event", "page_view", eventData);
  }
};
